export enum DocumentEditMode {
  EDIT_EN = "EDIT_EN",
  EDIT_NON_EN = "EDIT_NON_EN",
  EDIT_EN_TRANSLATION = "EDIT_EN_TRANSLATION",
  EDIT_TRANSLATION = "EDIT_TRANSLATION",
  CREATE_TRANSLATION = "CREATE_TRANSLATION",
}
